import React from "react";
import "../../css/PlayButton.css"; // 👉 CSS جداگانه

const PlayButton = ({ onClick }) => {
  return (
    // <div className="page-bg">
      <div className="glass-play" onClick={onClick}>
        <svg className="glass-icon" viewBox="0 0 24 24">
          <polygon points="8,5 19,12 8,19" />
        </svg>
        <span className="pulse"></span>
      </div>
    // </div>
  );
};

export default PlayButton;
